<template><div><h3>Panel_COM</h3>
<img width="100" src="http://qr.topscan.com/api.php?text=https%3A%2F%2Fvux.li%2Fdemos%2Fv2%2F%23%2Fcomponent%2Fpanel"/>
<p><a href="https://vux.li/demos/v2/#/component/panel" target="_blank" style="font-size:12px;color:#888;">demo 原始链接：https://vux.li/demos/v2/#/component/panel</a></p>
<hr>
<h4>演示</h4>
 <div style="width:377px;height:667px;display:inline-block;border:1px dashed #ececec;border-radius:5px;overflow:hidden;">
   <iframe src="https://vux.li/demos/v2/#/component/panel" width="375" height="667" border="0" frameborder="0"></iframe>
 </div>
<h4>demo 代码</h4>
<p class="tip">下面的$t是Demo的i18n使用的翻译函数，一般情况下可以直接使用字符串。另外，下面代码隐藏了i18n标签部分的代码。</p>
<pre class="hljs"><code><span class="hljs-tag">&lt;<span class="hljs-name">template</span>&gt;</span>
  <span class="hljs-tag">&lt;<span class="hljs-name">div</span>&gt;</span>
    <span class="hljs-tag">&lt;<span class="hljs-name">group</span> <span class="hljs-attr">:title</span>=<span class="hljs-string">"$t('Switch the type')"</span>&gt;</span>
      <span class="hljs-tag">&lt;<span class="hljs-name">radio</span> <span class="hljs-attr">title</span>=<span class="hljs-string">"type"</span> <span class="hljs-attr">v-model</span>=<span class="hljs-string">"type"</span> <span class="hljs-attr">:options</span>=<span class="hljs-string">"['1', '2', '3', '4', '5']"</span>&gt;</span><span class="hljs-tag">&lt;/<span class="hljs-name">radio</span>&gt;</span>
    <span class="hljs-tag">&lt;/<span class="hljs-name">group</span>&gt;</span>
    <span class="hljs-tag">&lt;<span class="hljs-name">panel</span> <span class="hljs-attr">:header</span>=<span class="hljs-string">"$t('List of content with image')"</span> <span class="hljs-attr">:footer</span>=<span class="hljs-string">"footer"</span> <span class="hljs-attr">:list</span>=<span class="hljs-string">"list"</span> <span class="hljs-attr">:type</span>=<span class="hljs-string">"type"</span> <span class="hljs-attr">@on-img-error</span>=<span class="hljs-string">"onImgError"</span>&gt;</span><span class="hljs-tag">&lt;/<span class="hljs-name">panel</span>&gt;</span>
  <span class="hljs-tag">&lt;/<span class="hljs-name">div</span>&gt;</span>
<span class="hljs-tag">&lt;/<span class="hljs-name">template</span>&gt;</span>



<span class="hljs-tag">&lt;<span class="hljs-name">script</span>&gt;</span><span class="javascript">
<span class="hljs-keyword">import</span> { Panel, Group, Radio } <span class="hljs-keyword">from</span> <span class="hljs-string">'vux'</span>

<span class="hljs-keyword">export</span> <span class="hljs-keyword">default</span> {
  <span class="hljs-attr">components</span>: {
    Panel,
    Group,
    Radio
  },
  <span class="hljs-attr">methods</span>: {
    onImgError (item, $event) {
      <span class="hljs-built_in">console</span>.log(item, $event)
    }
  },
  data () {
    <span class="hljs-keyword">return</span> {
      <span class="hljs-attr">type</span>: <span class="hljs-string">'1'</span>,
      <span class="hljs-attr">list</span>: [{
        <span class="hljs-attr">src</span>: <span class="hljs-string">'http://somedomain.somdomain/x.jpg'</span>,
        <span class="hljs-attr">fallbackSrc</span>: <span class="hljs-string">'http://placeholder.qiniudn.com/60x60/3cc51f/ffffff'</span>,
        <span class="hljs-attr">title</span>: <span class="hljs-string">'标题一'</span>,
        <span class="hljs-attr">desc</span>: <span class="hljs-string">'由各种物质组成的巨型球状天体，叫做星球。星球有一定的形状，有自己的运行轨道。'</span>,
        <span class="hljs-attr">url</span>: <span class="hljs-string">'/component/cell'</span>
      }, {
        <span class="hljs-attr">src</span>: <span class="hljs-string">'http://placeholder.qiniudn.com/60x60/3cc51f/ffffff'</span>,
        <span class="hljs-attr">title</span>: <span class="hljs-string">'标题二'</span>,
        <span class="hljs-attr">desc</span>: <span class="hljs-string">'由各种物质组成的巨型球状天体，叫做星球。星球有一定的形状，有自己的运行轨道。'</span>,
        <span class="hljs-attr">url</span>: {
          <span class="hljs-attr">path</span>: <span class="hljs-string">'/component/radio'</span>,
          <span class="hljs-attr">replace</span>: <span class="hljs-literal">false</span>
        },
        <span class="hljs-attr">meta</span>: {
          <span class="hljs-attr">source</span>: <span class="hljs-string">'来源信息'</span>,
          <span class="hljs-attr">date</span>: <span class="hljs-string">'时间'</span>,
          <span class="hljs-attr">other</span>: <span class="hljs-string">'其他信息'</span>
        }
      }],
      <span class="hljs-attr">footer</span>: {
        <span class="hljs-attr">title</span>: <span class="hljs-keyword">this</span>.$t(<span class="hljs-string">'more'</span>),
        <span class="hljs-attr">url</span>: <span class="hljs-string">'http://vux.li'</span>
      }
    }
  }
}
</span><span class="hljs-tag">&lt;/<span class="hljs-name">script</span>&gt;</span>

</code></pre>
<h4>Github Issue</h4>
</div></template><script>
export default {
  head: {"title":" | VUX - Vue 移动端 UI 组件库","ignoreSuffixChar":"|"}
}
  </script>


// WEBPACK FOOTER //
// panel-392.vue?e775a116